import { BaseRepository } from './BaseRepository';
import { supabase } from '../supabase';

export interface CompanyConfig {
  id: string;
  name: string;
  company_name: string;
  is_active: boolean;
  queue_id: string | null;
  elevenlabs_agent_id?: string;
  phone_number?: string;
  disclaimer_voice_id?: string;
  agent_voice_id?: string;
  agent_id?: string;
  knowledge_base_ids?: string[];
  rules?: any;
  system_prompt?: string;
  mcp_token?: string | null;
  agent_personality?: {
    tone: string;
    pace: string;
    empathy_level: string;
  };
  conversation_starters?: string[];
  disclaimer_audio_url?: string;
  created_at?: string;
  updated_at?: string;
}

export class CompanyConfigRepository extends BaseRepository<CompanyConfig> {
  constructor() {
    super({ tableName: 'company_configs', primaryKey: 'id' });
  }

  /**
   * Get all active companies
   */
  async getActiveCompanies(): Promise<CompanyConfig[]> {
    const { data, error } = await supabase
      .from(this.getTableName())
      .select('*')
      .eq('is_active', true)
      .order('name');

    if (error) throw error;
    return data || [];
  }

  /**
   * Get active companies count
   */
  async getActiveCompaniesCount(): Promise<number> {
    const { count, error } = await supabase
      .from(this.getTableName())
      .select('id', { count: 'exact', head: true })
      .eq('is_active', true);

    if (error) throw error;
    return count || 0;
  }

  /**
   * Update company active status
   */
  async updateActiveStatus(id: string, isActive: boolean): Promise<CompanyConfig> {
    const { data, error } = await supabase
      .from(this.getTableName())
      .update({ is_active: isActive, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  }
}
